import { userContext } from '../userManager';

export const apiAumsGet = ({ startDate, endDate }) =>
  userContext.apiCall({
    url: `/aums`,
    qs: { startDate, endDate },
  });
